var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_62307_124521)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_62307_124521",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -8,
    y: -7,
    width: 52,
    height: 51
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-7.20142 -6.70031H43.1986V43.6996H-7.20142V-6.70031Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_62307_124521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9993 18.4998C35.9993 8.55872 27.9404 0.49984 17.9993 0.49984C8.05815 0.49984 -0.000732422 8.55872 -0.000732422 18.4998C-0.000732422 26.9415 5.81075 34.0246 13.6509 35.9697V24.0003H9.93915V18.4998H13.6509V16.1297C13.6509 10.003 16.4235 7.16336 22.4384 7.16336C23.5787 7.16336 25.5464 7.38692 26.3513 7.61056V12.5968C25.9265 12.5521 25.1886 12.5297 24.2718 12.5297C21.3203 12.5297 20.1799 13.6477 20.1799 16.5545V18.4998H26.0594L25.0494 24.0003H20.1799V36.368C29.0925 35.2915 35.9993 27.7027 35.9993 18.4998Z",
    fill: "#0866FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0487 24.0003L26.0588 18.4998H20.1793V16.5545C20.1793 13.6477 21.3197 12.5297 24.2712 12.5297C25.1879 12.5297 25.9258 12.5521 26.3507 12.5968V7.61056C25.5457 7.38693 23.578 7.1633 22.4377 7.1633C16.4229 7.1633 13.6502 10.003 13.6502 16.1297V18.4998H9.93848V24.0003H13.6502V35.9698C15.0429 36.3152 16.4991 36.4998 17.9986 36.4998C18.7369 36.4998 19.4644 36.4543 20.1793 36.368V24.0003H25.0487Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62307_124521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogo);
export default __webpack_public_path__ + "static/media/facebook_logo.fee9c707fbaf68f4841a78894dc4c98c.svg";
export { ForwardRef as ReactComponent };